import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeleteConfirmationModalComponent } from '../modals';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-prof-exp-component',
    templateUrl: './prof-exp-component.html',
    styleUrls: ['./prof-exp-component.scss']
})

export class ProfExperienceComponent implements OnInit {
    @Input() data_array : Array<any>;
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();

    constructor(private modalService: NgbModal) {
    	
    }

    ngOnInit() {}

    deleteAction(data){
        const modalRef = this.modalService.open(DeleteConfirmationModalComponent);
              const p1 = data.company_id ? data.company.company_name_en : data.company_name
              const p2 = data.job_title
              modalRef.componentInstance.Title = " "+p1+"/"+p2;
              modalRef.result.then((result) => {
                    if(result.status)
                        this.delete.emit(data.id);
                  }).catch((error) => {
              });
    }

    editAction(data){
      //deep copy
        this.edit.emit({... data});
    }
}
